var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeptChats = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19788"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19464",
  transform: "translate(0 .067)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "none",
  "data-name": "Ellipse 1391",
  transform: "translate(0 -.068)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  "data-name": "Group 19773",
  transform: "translate(-61.479 -444.001)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m90.251 472.133.463 2.265 2.2-2.489.007.02a3.49 3.49 0 0 0 2.302-3.282v-7.362a3.485 3.485 0 0 0-3.485-3.486h-10.52a3.485 3.485 0 0 0-3.486 3.486v7.363a3.49 3.49 0 0 0 2.255 3.262l2.2 2.489.561-2.265h1.875l1.777 2.265 1.937-2.265Z",
  "data-name": "Path 27432"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.974,
  cy: 1.974,
  r: 1.974,
  strokeLinejoin: "round",
  "data-name": "Ellipse 1643",
  transform: "translate(84.326 476.254)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.974,
  cy: 1.974,
  r: 1.974,
  strokeLinejoin: "round",
  "data-name": "Ellipse 1644",
  transform: "translate(78.701 476.254)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.974,
  cy: 1.974,
  r: 1.974,
  strokeLinejoin: "round",
  "data-name": "Ellipse 1645",
  transform: "translate(89.953 476.254)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M84.276 467.042h4.631m-7.054-3.716h9.262",
  "data-name": "Path 27433"
})))));
export { SvgDeptChats as ReactComponent };
export default __webpack_public_path__ + "static/media/dept_chats.49ac296b7b07fea790a71d93f2e23ada.svg";